import { theme } from 'aimo-ui';
import ServicesDefault from 'components/services/ServicesDefault';
import StackHeader, { StackHeaderCustomProps } from 'navigation/StackHeader';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PrepaidTicket from 'screens/prepaidTickets/PrepaidTicket';
import PrepaidTickets from 'screens/prepaidTickets/PrepaidTickets';
import { ServicesStackParamList } from 'types/navigation';
import { isWeb } from 'utils/deviceUtils';
import { createStackNavigator } from 'utils/navigationHelpers';
import { testIdentifiers } from 'utils/testIdentifiers';
import HslNavigator from './HslNavigator';
import { PrepaidTicketEditWithLayout } from './ParkNavigator';

const ServicesStack = createStackNavigator<ServicesStackParamList>();

const CustomHeaderComponent = (props: StackHeaderCustomProps) => (
  <StackHeader {...props} useInsetForTop background={theme.colors.gray100} />
);

const MainHeader = (props: StackHeaderCustomProps) => (
  <StackHeader
    {...props}
    {...testIdentifiers('services-main-title')}
    useInsetForTop
    titleSize="large"
    headerBackIconVisible={false}
    background={isWeb ? theme.colors.white : theme.colors.gray100}
  />
);

const ServicesNavigator: React.FC = () => {
  const { t } = useTranslation();

  return (
    <ServicesStack.Navigator
      screenOptions={{
        headerTransparent: isWeb,
        cardStyle: {
          backgroundColor: isWeb ? theme.colors.white : theme.colors.gray100,
        },
        header: CustomHeaderComponent,
      }}>
      <ServicesStack.Screen
        name="servicesMain"
        component={ServicesDefault}
        options={{
          title: t('services.mainTitle'),
          header: MainHeader,
        }}
      />
      <ServicesStack.Screen
        name="prepaidTickets"
        component={PrepaidTickets}
        options={{
          title: t('services.prepaidTickets'),
          headerTransparent: false,
          headerShown: true,
          cardStyle: {
            backgroundColor: theme.colors.gray100,
          },
        }}
      />
      <ServicesStack.Screen
        name="prepaidTicket"
        component={PrepaidTicket}
        options={{
          headerTransparent: false,
          cardStyle: {
            backgroundColor: theme.colors.gray100,
          },
        }}
      />
      <ServicesStack.Screen
        name="prepaidEdit"
        component={PrepaidTicketEditWithLayout}
        options={{
          title: t('parking.prepaidTickets.editPrepaidTitle'),
          cardStyle: { backgroundColor: theme.colors.white },
        }}
      />
      <ServicesStack.Screen
        name="hslNavigator"
        component={HslNavigator}
        options={{
          headerShown: false,
        }}
      />
    </ServicesStack.Navigator>
  );
};

export default ServicesNavigator;
